import { Facebook, GitHub, Instagram, Twitter } from "@material-ui/icons";
import logo from "../assets/images/logo.png";

const Footer = () => {
  return (
    <div className="bg-gray-900 sm:h-[60vh] bg-gradient-to-r from-gray-900 via-gray-900 to-gray-800  border-t-4 border-gray-700">
      <div className="sm:w-[80%] sm:ml-auto sm:mr-auto">
        <div className="flex justify-center sm:justify-start p-3">
          <img src={logo} alt="" />
        </div>
        <div className="p-3">
          <h1 className="text-gray-400 text-base font-bold">
            Questions call? 000-800-040-1843
          </h1>
        </div>
        <div className="text-gray-400 cursor-pointer text-base font-bold p-3 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
          <div className="space-y-3">
            <p>FAQ</p>
            <p>Investor Relations</p>
            <p>Privacy</p>
            <p>Speed Test</p>
          </div>
          <div className="space-y-3">
            <p>Help Center</p>
            <p>Jobs</p>
            <p>Cookie Preferences</p>
            <p>Legal Notices</p>
          </div>
          <div className="space-y-3">
            <p>Account</p>
            <p>Ways to Watch</p>
            <p>Corporate Inforamation</p>
            <p>Andromeda Originals</p>
          </div>
          <div className="space-y-3">
            <p>Media Center</p>
            <p>Term of Use</p>
            <p>Contact Us</p>
          </div>
          <div className="space-y-3">
            <p>Customer care</p>
            <p>Email: andromeda@help.co.in</p>
          </div>
        </div>

        <div className="p-3 mt-5 border-t border-gray-600">
          <div className="flex sm:justify-between mt-3 items-center">
            <div className="flex items-center space-x-3">
              <Facebook className="text-gray-300 mr-2" />
              <Instagram className="text-gray-300 mr-2" />
              <Twitter className="text-gray-300 mr-2" />
              <GitHub className="text-gray-300 mr-2" />
            </div>
            <div>
              <p className="text-gray-400 font-bold text-base">
                @copy rights reserved @andromeda.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
